__webpack_require__.p = "https://wxapp.gzcmc.net/wxapp/test/news-template-webpack/";